import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { StoreState } from '~/reducers';

export const useCobuSelector: TypedUseSelectorHook<StoreState> = useSelector;
